// export const navigation = [
//   {
//     text: 'Home',
//     path: '/home',
//     icon: 'home'
//   },
//   {
//     text: 'Azienda',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Controllo Gestione',
//         path: '/company-management',
//         icon: 'chart'
//       }
//       ,
//       {
//         text: 'Documenti',
//         path: '/documents',
//         icon: 'pdffile'
//       }
  
//     ]
//   },
//   {
//     text: 'Anagrafica',
//     path: '/subjects',
//     icon: 'group'
//   },
//   {
//     text: 'Collaboratori',
//     path: '/collaborators',
//     icon: 'runner'
//   },
//   {
//     text: 'Commesse',
//     path: '/projects',
//     icon: 'globe'
//   },
//   {
//     text: 'Offerte',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Elenco',
//         path: '/offers',
//         icon: 'rowfield'
//       },
//       {
//         text: 'Avanzamento',
//         path: '/offers-progress',
//         icon: 'rowfield'
//       },
//       {
//         text: 'Attività',
//         path: '/offer-activities',
//         icon: 'clock'
//       }
//     ]
//   },
//   {
//     text: 'Ordini Clienti',
//     path: '/customer-orders',
//     icon: 'hidepanel'
//   }, 
//   {
//     text: 'Ordini Fornitori',
//     path: '/supplier-orders',
//     icon: 'showpanel'
//   }, 
//   {
//     text: 'Fatture Clienti',
//     path: '/customer-invoices',
//     icon: 'money'
//   },
//   {
//     text: 'Fatture Fornitori',
//     path: '/supplier-invoices',
//     icon: 'money'
//   },
//   {
//     text: 'Gestione',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Movimenti',
//         icon: 'menu',
//         path: '/timetable'
//       },
//       {
//         text: 'Attività',
//         icon: 'alignleft',
//         path: '/activities'
//       },
//       {
//         text: 'Notifiche FE',
//         path: '/fenotices',
//         icon: 'bell'
//       }
//     ]
//   },
//   {
//     text: 'Articoli',
//     path: '/articles',
//     icon: 'product'
//   },
//   {
//     text: 'Utenti',
//     path: '/users',
//     icon: 'card'
//   },
//   {
//     text: 'Tabelle',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Cond. Pagamento',
//         path: '/payment-cond',
//         icon: 'verticalaligncenter'
//       },
//       {
//         text: 'Mod. Pagamento',
//         path: '/payment-modal',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Pagamenti',
//         path: '/payments',
//         icon: 'cart'
//       },
//       {
//         text: 'Valute',
//         path: '/currencies',
//         icon: 'verticalaligncenter'
//       },
//       {
//         text: 'Contatori',
//         path: '/counters',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Categ. Analitiche',
//         path: '/analytics-categories',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Categ. Documenti',
//         path: '/document-categories',
//         icon: 'columnchooser'
//       }
//     ]
//   }
  
// ];

// export const navigationManager = [
//   {
//     text: 'Home',
//     path: '/home',
//     icon: 'home'
//   },
//   {
//     text: 'Anagrafica',
//     path: '/subjects',
//     icon: 'group'
//   },
//   {
//     text: 'Collaboratori',
//     path: '/collaborators',
//     icon: 'runner'
//   },
//   {
//     text: 'Commesse',
//     path: '/projects',
//     icon: 'globe'
//   },
//   {
//     text: 'Offerte',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Elenco',
//         path: '/offers',
//         icon: 'rowfield'
//       },
//       {
//         text: 'Avanzamento',
//         path: '/offers-progress',
//         icon: 'rowfield'
//       }, 
//       {
//         text: 'Attività',
//         path: '/offer-activities',
//         icon: 'clock'
//       }
//     ]
//   },
//   {
//     text: 'Ordini Clienti',
//     path: '/customer-orders',
//     icon: 'hidepanel'
//   }, 
//   {
//     text: 'Ordini Fornitori',
//     path: '/supplier-orders',
//     icon: 'showpanel'
//   },  
//   {
//     text: 'Gestione',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Movimenti',
//         icon: 'menu',
//         path: '/timetable'
//       },
//       {
//         text: 'Attività',
//         icon: 'alignleft',
//         path: '/activities'
//       },
//       {
//         text: 'Notifiche FE',
//         path: '/fenotices',
//         icon: 'bell'
//       }
//     ]
//   },
//   {
//     text: 'Articoli',
//     path: '/articles',
//     icon: 'product'
//   },
//   {
//     text: 'Tabelle',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Cond. Pagamento',
//         path: '/payment-cond',
//         icon: 'verticalaligncenter'
//       },
//       {
//         text: 'Mod. Pagamento',
//         path: '/payment-modal',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Pagamenti',
//         path: '/payments',
//         icon: 'cart'
//       },
//       {
//         text: 'Valute',
//         path: '/currencies',
//         icon: 'verticalaligncenter'
//       },
//       {
//         text: 'Contatori',
//         path: '/counters',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Categ. Analitiche',
//         path: '/analytics-categories',
//         icon: 'verticalaligncenter'
//       }
//     ]
//   }
  
// ];

// export const navigationOfficeManager = [
//   {
//     text: 'Home',
//     path: '/home',
//     icon: 'home'
//   },
//   {
//     text: 'Anagrafica',
//     path: '/subjects',
//     icon: 'group'
//   },
//   {
//     text: 'Collaboratori',
//     path: '/collaborators',
//     icon: 'runner'
//   },
//   {
//     text: 'Commesse',
//     path: '/projects',
//     icon: 'globe'
//   },
//   {
//     text: 'Offerte',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Elenco',
//         path: '/offers',
//         icon: 'rowfield'
//       },
//       {
//         text: 'Avanzamento',
//         path: '/offers-progress',
//         icon: 'rowfield'
//       }
//     ]
//   },
//   {
//     text: 'Ordini Clienti',
//     path: '/customer-orders',
//     icon: 'hidepanel'
//   }, 
//   {
//     text: 'Ordini Fornitori',
//     path: '/supplier-orders',
//     icon: 'showpanel'
//   },  
//   {
//     text: 'Fatture Clienti',
//     path: '/customer-invoices',
//     icon: 'money'
//   },
//   {
//     text: 'Fatture Fornitori',
//     path: '/supplier-invoices',
//     icon: 'money'
//   },
//   {
//     text: 'Gestione',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Movimenti',
//         icon: 'menu',
//         path: '/timetable'
//       },
//       {
//         text: 'Attività',
//         icon: 'alignleft',
//         path: '/activities'
//       },
//       {
//         text: 'Notifiche FE',
//         path: '/fenotices',
//         icon: 'bell'
//       }
//     ]
//   },
//   {
//     text: 'Articoli',
//     path: '/articles',
//     icon: 'product'
//   },
//   {
//     text: 'Tabelle',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Cond. Pagamento',
//         path: '/payment-cond',
//         icon: 'verticalaligncenter'
//       },
//       {
//         text: 'Mod. Pagamento',
//         path: '/payment-modal',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Pagamenti',
//         path: '/payments',
//         icon: 'cart'
//       },
//       {
//         text: 'Valute',
//         path: '/currencies',
//         icon: 'verticalaligncenter'
//       },
//       {
//         text: 'Contatori',
//         path: '/counters',
//         icon: 'verticalaligncenter'
//       }, 
//       {
//         text: 'Categ. Analitiche',
//         path: '/analytics-categories',
//         icon: 'verticalaligncenter'
//       }
//     ]
//   }
  
// ];
  
// export const navigationOperator = [
//   {
//     text: 'Home',
//     path: '/home',
//     icon: 'home'
//   },
//   {
//     text: 'Anagrafica',
//     path: '/subjects',
//     icon: 'group'
//   },
//   {
//     text: 'Offerte',
//     path: '/offers',
//     icon: 'rowfield'
//   }, 
  
//   {
//     text: 'Ordini Clienti',
//     path: '/customer-orders',
//     icon: 'hidepanel'
//   }, 
//   {
//     text: 'Ordini Fornitori',
//     path: '/supplier-orders',
//     icon: 'showpanel'
//   },
//   {
//     text: 'Gestione',
//     icon: 'folder',
//     items: [
//       {
//         text: 'Movimenti',
//         icon: 'menu',
//         path: '/timetable'
//       }
//     ]
//   },
//   {
//     text: 'Articoli',
//     path: '/articles',
//     icon: 'product'
//   }


// ];

export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Azienda',
    icon: 'folder',
    roles: ['admin','officeManager','securityManager'],
    items: [
      {
        text: 'Controllo Gestione',
        path: '/company-management',
        icon: 'chart',
        roles: ['admin']
      },
      {
        text: 'Documenti',
        path: '/documents',
        icon: 'pdffile',
        roles: ['admin','officeManager','securityManager']
      }
    ]
  },
  {
    text: 'Anagrafica',
    path: '/subjects',
    icon: 'group'
  },
  {
    text: 'Collaboratori',
    path: '/collaborators',
    icon: 'runner',
    roles: ['admin', 'officeManager','securityManager']
  },
  {
    text: 'Commesse',
    icon: 'folder',
    roles: ['admin', 'manager', 'officeManager','securityManager'],
    items:[
       {
        text: 'Elenco',
        path: '/projects',
        icon: 'globe',
        roles: ['admin', 'manager', 'officeManager','securityManager']
      },   
      {
        text: 'Attività',
        path: '/project-activities',
        icon: 'clock',
        roles: ['admin', 'manager', 'officeManager','securityManager']
      }
    ]
  },
  {
    text: 'Offerte',
    icon: 'folder',
    roles: ['admin', 'manager', 'officeManager'],
    items: [
      {
        text: 'Elenco',
        path: '/offers',
        icon: 'rowfield',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Avanzamento',
        path: '/offers-progress',
        icon: 'rowfield',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Attività',
        path: '/offer-activities',
        icon: 'clock',
        roles: ['admin', 'manager']
      }, 
      {
        text: 'Fornitore',
        path: '/offers-by-supplier',
        icon: 'hierarchy',
        roles: ['admin', 'manager']
      }
    ]
  },
  {
    text: 'Offerte',
    path: '/offers',
    icon: 'rowfield',
    roles: ['operator']
  },
  {
    text: 'Ordini Clienti',
    path: '/customer-orders',
    icon: 'hidepanel',
    roles: ['admin', 'manager', 'officeManager', 'operator']
  },
  {
    text: 'Ordini Fornitori',
    path: '/supplier-orders',
    icon: 'showpanel',
    roles: ['admin', 'manager', 'officeManager', 'operator']
  },
  {
    text: 'Fatture Clienti',
    path: '/customer-invoices',
    icon: 'money',
    roles: ['admin', 'officeManager']
  },
  {
    text: 'Fatture Fornitori',
    path: '/supplier-invoices',
    icon: 'money',
    roles: ['admin', 'officeManager']
  },
  {
    text: 'Registrazione Spese',
    path: '/costs',
    icon: 'gift',
    roles: ['admin', 'officeManager']
  },
  {
    text: 'Gestione',
    icon: 'folder',
    roles: ['admin', 'manager', 'officeManager', 'operator'],
    items: [
      {
        text: 'Attività',
        icon: 'alignleft',
        path: '/activities',
        roles: ['admin', 'manager', 'officeManager', 'operator']
      }
    ]
  },
  {
    text: 'Contabilità',
    icon: 'folder',
    roles: ['admin', 'officeManager'],
    items: [
      {
        text: 'Movimenti',
        icon: 'menu',
        path: '/timetable',
        roles: ['admin', 'officeManager']
      }, 
      {
        text: 'Prima nota',
        path: '/journal-entry',
        icon: 'orderedlist',
        roles: ['admin', 'officeManager']
      },
      {
        text: 'Notifiche FE',
        path: '/fenotices',
        icon: 'bell',
        roles: ['admin', 'officeManager']
      }, 
      {
        text: 'FE Cloud',
        path: '/fecloud',
        icon: 'comment',
        roles: ['admin', 'officeManager']
      }
    ]
  },
  {
    text: 'Reports',
    path: '/reports',
    icon: 'chart',
    roles: ['admin', 'manager', 'officeManager']
  },
  {
    text: 'Articoli',
    path: '/articles',
    icon: 'product',
    roles: ['admin', 'manager', 'officeManager', 'operator']
  },
  {
    text: 'Utenti',
    path: '/users',
    icon: 'card',
    roles: ['admin']
  },
  {
    text: 'Tabelle',
    icon: 'folder',
    roles: ['admin', 'manager', 'officeManager'],
    items: [
      {
        text: 'Cond. Pagamento',
        path: '/payment-cond',
        icon: 'verticalaligncenter',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Mod. Pagamento',
        path: '/payment-modal',
        icon: 'verticalaligncenter',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Pagamenti',
        path: '/payments',
        icon: 'cart',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Valute',
        path: '/currencies',
        icon: 'verticalaligncenter',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Contatori',
        path: '/counters',
        icon: 'verticalaligncenter',
        roles: ['admin', 'manager', 'officeManager']
      },
      {
        text: 'Categ. Analitiche',
        path: '/analytics-categories',
        icon: 'verticalaligncenter',
        roles: ['admin', 'officeManager']
      },
      {
        text: 'Categ. Documenti',
        path: '/document-categories',
        icon: 'columnchooser',
        roles: ['admin','officeManager']
      }
    ]
  }



];
    
  
